export default __webpack_public_path__ + "static/Drift-f3ec9101ed332708868f0908378c1cf9.png";